/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Terrace_AreaInputs */

const cs_form_terrace_area = /** @type {(inputs: Form_Terrace_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha terasy (m²)`)
};

const en_form_terrace_area = /** @type {(inputs: Form_Terrace_AreaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terrace area (m²)`)
};

/**
* | output |
* | --- |
* | "Terrace area (m²)" |
*
* @param {Form_Terrace_AreaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_terrace_area = /** @type {((inputs?: Form_Terrace_AreaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Terrace_AreaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_terrace_area(inputs)
	return cs_form_terrace_area(inputs)
});